<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>Document Files</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tooltip left class="mr-0">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="openUppyDashboard">
            <v-icon dark>add</v-icon>
          </v-btn>
        </template>
        <span>Add new files</span>
      </v-tooltip>

    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="relatedFiles"
      class="elevation-1"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            <a :href="props.item.file_url" target="_blank">{{ props.item.name }}</a>
          </td>
          <td>{{ props.item.meta_caption }}</td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  small
                  v-on="on"
                  @click="() => onPressFileDelete(props.item.id)"
                >
                  <v-icon dark>clear</v-icon>
                </v-btn>
              </template>
              <span>Delete file</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <template slot="no-data"> </template>
    </v-data-table>
  </v-card>
</template>

<script>
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import Uppy from "@uppy/core";
import Dashboard from "@uppy/dashboard";
// import Tus from "@uppy/tus";
import Url from "@uppy/url";
import Webcam from "@uppy/webcam";
import XHRUpload from "@uppy/xhr-upload";

export default {
  props: {
    ofID: {
      type: Number,
      required: true,
    },
    ofName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      relatedFiles: [],
      headers: [
        { text: "File Name", value: "name", sortable: false },
        { text: "Caption", value: "name", sortable: false },
        { text: "Actions", value: "name", sortable: false },
      ],
    };
  },

  computed: {
    isValidOfValues() {
      return this.ofID && this.ofName;
    },
  },

  methods: {
    async loadRelatedFiles() {
      if (this.isValidOfValues) {
        const fileRes = await this.getUpload(this.ofID, this.ofName);
        this.relatedFiles = fileRes.data.data;
      } else {
        this.relatedFiles = [];
      }
    },
    async onPressFileDelete(fileID) {
      this.$confirm("Do you really want to DELETE file ?").then(async (isConfirmed) => {
        if (isConfirmed) {
          const res = await this.deleteUpload(fileID);
          if (res.data.success) {
            this.relatedFiles = this.relatedFiles.filter((r) => r.id != fileID);
          }
          this.snackbarShow(res.data);
        }
      });
    },

    openUppyDashboard() {
      this.uppy.getPlugin("Dashboard").openModal();
    },
    initUppy() {
      if (!this.isValidOfValues) {
        return;
      }

      if (this.uppy) {
        this.uppy.close();
      }

      this.uppy = Uppy({
        autoProceed: false,
        restrictions: {
          maxFileSize: 5242880, // 5 MB
          allowedFileTypes: [
            ".jpg",
            ".jpeg",
            ".png",
            ".doc",
            ".docx",
            ".pdf",
            ".xls",
            ".xlsx",
          ],
        },
      })
        .use(Dashboard, {
          proudlyDisplayPoweredByUppy: false,
          metaFields: [
            // { id: 'name', name: 'Name', placeholder: 'file name' },
            {
              id: "meta_caption",
              name: "Caption",
              placeholder: "describe what the image is about",
            },
          ],
        })
        .use(XHRUpload, {
          headers: {
            authorization: this.authToken,
          },
          endpoint: this.$UPLOAD_URL,
          fieldName: "files",
        });

      this.uppy.on("file-added", (file) => {
        this.uppy.setFileMeta(file.id, {
          size: file.size,
          extension: file.extension,
          of_name: this.ofName,
          of_id: this.ofID,
          old_file_name: "",
        });
      });

      this.uppy.on("complete", (result) => {
        // console.log("complete", result);
        // console.log("successful files:", result.successful);
        // console.log("failed files:", result.failed);
      });

      this.uppy.on("upload-success", (file, res) => {
        let body = res.body;
        if (body.success) {
          // this.offerPhoto = body.data.thumb_url;
          // this.uppy.getPlugin("Dashboard").closeModal();
          this.relatedFiles = body.data.files;
        }
      });
    },
  },

  mounted() {
    // this.initUppy();
  },

  watch: {
    ofID(val, oldVal) {
      if (val != oldVal) {
        this.initUppy();
        this.loadRelatedFiles();
      }
    },
    ofName(val, oldVal) {
      if (val != oldVal) {
        this.initUppy();
        this.loadRelatedFiles();
      }
    },
  },

  beforeDestroy() {
    this.uppy.close();
  },

  created() {},
};
</script>
